const PageContentStack = ({ children, className = "" }) => (
  <div
    className={`tw-mx-auto tw-flex tw-w-full tw-max-w-[600px] tw-flex-col tw-gap-4 ${className}`}
  >
    {children}
  </div>
);

export default PageContentStack;
